<template>
  <v-card flat class="mt-5">
    <v-card-title>Cloud Pro API Subscription</v-card-title>
    <v-card-text>
      <v-alert dense outlined type="error" v-if="error">{{ errorText }}</v-alert>
      <div v-if="loading" class="text-center pa-3">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div v-else>
        <p>
          Entitled: <strong>{{ usage && usage.entitled ? 'Yes' : 'No' }}</strong>
        </p>
        <p v-if="usage">
          Usage {{ usage.used }} / {{ usage.allowance }} ({{ usage.percent }}%).
          Reset {{ formattedResetAt }}.
        </p>
        <v-data-table
          :headers="headers"
          :items="(usage && usage.active_licenses) || []"
          hide-default-footer
          dense
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'OrgApiSubscription',
    props: {
      org_guid: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loading: true,
        error: false,
        errorText: '',
        usage: null,
        headers: [
          { text: 'License', value: 'license_name' },
          { text: 'Profile', value: 'profile_guid' },
          { text: 'Allowance', value: 'allowance' },
          { text: 'Expires', value: 'expires' },
          { text: 'Sales Order', value: 'sales_order' },
        ]
      }
    },
    computed: {
      formattedResetAt() {
        return this.usage && this.usage.reset_at
          ? moment(this.usage.reset_at).format('MMM D, YYYY HH:mm Z')
          : 'unknown'
      },
    },
    mounted() {
      this.axios.get('/usage/admin', { params: { org_guid: this.org_guid } }).then((response) => {
        const orgs = response.data.organizations || []
        this.usage = orgs[0] || null
        this.loading = false
      }).catch((error) => {
        this.error = true
        this.errorText = this.$helpers.parseError(error)
        this.loading = false
      })
    }
  }
</script>
